import React, { useRef, useState } from 'react';
const { default: LetterDrawingComp } = require("./letterDrawingComp");

export const TraceLetterGame = () => {
  return (
    <LetterDrawingComp type="sequence"/>
  );
};
